import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import PageHeader from "../components/PageHeader";
import BackToTop from "../components/BackToTop";
import logo from "../assets/logo192.png";
import '../css/WhatWeDo.css';
import Client from "../components/Client";

export default function WhatWeDo() {

const objectives = [
"सार्वजनिक रूप से महिलाओं को रोजगार प्रदान करना तथा मंदिर निर्माण, मेला आयोजन, अनाथालय, वृद्धाश्रम, अनुसंधान केन्द्र, छात्रावास, शिक्षण संस्थान, पंचायत भवन, निराश्रित आश्रय, सामुदायिक विकास केन्द्र, सर्वेक्षण केन्द्र, पर्यावरण एवं एड्स उत्थान केन्द्रों की स्थापना, विकास, प्रबंधन एवं संचालन करना तथा आवश्यकता होने पर संबंधित परिषदों, विभागों, संस्थानों एवं शासन से मान्यता/पंजीकरण प्राप्त करना।",

"ग्राम विकास अभिकरण से संबंधित योजनाओं का क्रियान्वयन एवं संचालन करना।",

"कृषि कार्य हेतु बंजर भूमि का सुधार, भूमि कटाव रोकना, जल संरक्षण एवं नमी संरक्षण तथा भूमि सुधार संबंधी सभी कार्य करना।",

"लोकहित में शैक्षिक संस्थानों एवं विद्यालयों का निर्माण एवं पुनर्निर्माण करना।",

"प्रतियोगी परीक्षाओं की तैयारी हेतु संस्थाओं की स्थापना करना।",

"केंद्र एवं राज्य सरकार के विभागों, मानव संसाधन, समाज कल्याण, नाबार्ड, कपार्ट, सामाजिक न्याय एवं अधिकारिता मंत्रालय, महिला कल्याण, युवा कल्याण, ग्राम विकास मंत्रालय आदि से संबंधित योजनाओं का संचालन करना।",

"आईटीआई, आईआईटी, पॉलिटेक्निक, इंजीनियरिंग, फार्मेसी, नर्सिंग, पैरामेडिकल, मेडिकल एवं अन्य तकनीकी संस्थानों की स्थापना एवं संचालन करना।",

"पुस्तकालय, वाचनालय, पत्र-पत्रिकाओं एवं समाचार पत्रों का प्रकाशन, मुद्रण, विक्रय एवं मूल्य निर्धारण करना।",

"अंधे, गूंगे, बहरे एवं असहाय व्यक्तियों हेतु शिक्षा, चिकित्सा, आवास एवं भोजन की व्यवस्था करना तथा महिला एवं बाल विकास कार्यक्रम संचालित करना।",

"विभिन्न विषयों (कला, विज्ञान, वाणिज्य, खेल, मार्शल आर्ट, संगीत, तकनीकी, सामाजिक, आधुनिक भाषा, उर्दू, अंग्रेजी, कंप्यूटर, प्रोफेशनल पाठ्यक्रम आदि) में शिक्षा प्रदान करना।",

"प्रतियोगी परीक्षाओं हेतु विद्यार्थियों को शिक्षण, आवास एवं अन्य सुविधाएं प्रदान कर उन्हें स्वावलंबी बनाना।",

"पुस्तक, साहित्य एवं पाठ्यक्रमों का सृजन, संपादन, प्रकाशन एवं वितरण करना।",

"सांस्कृतिक, पर्यावरण, एड्स जागरूकता, सेमिनार, गोष्ठी, सम्मेलन, प्रतियोगिता एवं विशेष कक्षाओं का आयोजन करना।",

"अन्य सोसायटी/ट्रस्ट द्वारा संचालित विद्यालयों, महाविद्यालयों, मेडिकल एवं इंजीनियरिंग कॉलेजों को अपने ट्रस्ट में समायोजित कर संचालन करना।",

"राष्ट्रीय एवं अंतरराष्ट्रीय संस्थाओं एवं व्यक्तियों से आर्थिक सहयोग प्राप्त करना अथवा प्रदान करना।",

"कृषि उपयोगी कार्यों का प्रचार-प्रसार करना।",

"पर्यावरण सुधार हेतु जागरूकता कार्यक्रम एवं सेमिनार आयोजित करना।",

"ट्रस्ट द्वारा दी जाने वाली सेवाओं/वस्तुओं के लिए उचित शुल्क/मूल्य निर्धारण करना।",

"पत्राचार द्वारा शिक्षा को प्रोत्साहित करना एवं आवश्यक व्यवस्थाएं करना।",

"जनकल्याण हेतु विभिन्न कार्यक्रमों का आयोजन एवं क्रियान्वयन करना।",

"छात्रवृत्ति, पुरस्कार, वित्तीय सहायता एवं स्मृति चिन्ह प्रदान करना।",

"विभिन्न संस्थाओं के विशेषाधिकार प्राप्त करना एवं प्रदान करना।",

"ट्रस्ट के कोष एवं संपत्ति में वृद्धि करना, निवेश करना एवं उद्देश्यों में उपयोग करना।",

"सड़क, खड़ंजा, तालाब निर्माण, मछली पालन, पशुपालन एवं मधुमक्खी पालन को बढ़ावा देना।",

"ट्रस्ट लाभ कमाने के उद्देश्य से कार्य नहीं करेगा, बल्कि जनकल्याण की भावना से कार्य करेगा।",

"ट्रस्ट की आय एवं लाभ केवल ट्रस्ट के उद्देश्यों की पूर्ति हेतु व्यय किए जाएंगे।",

"किसानों के विकास हेतु उन्नत बीज, फल एवं औषधीय खेती की जानकारी देना तथा आयात-निर्यात को प्रोत्साहित करना।",

"संगठन को मजबूत बनाने हेतु जिला, प्रदेश एवं राष्ट्रीय स्तर पर पदाधिकारियों का चयन करना।",

"दलित, पिछड़े एवं अल्पसंख्यकों के सामाजिक, राजनीतिक एवं आर्थिक सशक्तिकरण हेतु कार्य करना।",

"धरना, प्रदर्शन, गोष्ठी, सम्मेलन एवं वार्षिक अधिवेशन के माध्यम से अपनी बात शासन-प्रशासन तक पहुंचाना।",

"शिक्षा व्यवस्था को सुदृढ़ करने हेतु छात्रावासों का निर्माण करना।",

"गोवंश की रक्षा एवं विकास हेतु कार्य करना।",

"ट्रस्ट का कार्यक्षेत्र संपूर्ण भारत होगा तथा आवश्यकता अनुसार विदेशों में भी कार्य कर सकेगा।",

"उक्त नाम से अन्य कोई ट्रस्ट संचालित नहीं है।"
];

    
    return (
        
        <>
            <Navbar />
            <PageHeader 
                title="What We Do" 
                path="/what-we-do" 
                name="What We Do" 
            />

            <div className="what-we-do py-5">
                <div className="container">

                    {/* Heading + Logo */}
                    <div className="text-center mb-5">
                        <img src={logo} alt="NGO Logo" className="what-logo mb-3" />
                        <h2 className="main-heading">हम क्या करते हैं</h2>
                        <p className="subtitle">
                            ट्रस्ट निम्नलिखित उद्देश्यों की पूर्ति हेतु कार्य करेगा –
                        </p>
                    </div>

                    {/* Objectives List */}
                    <div className="objectives">
    <ul>
        {objectives.map((point, index) => (
            <li key={index}>
                <span className="point-number">{index + 1}.</span> {point}
            </li>
        ))}
    </ul>
</div>


                </div>
            </div>
  <Client/>
            <Footer />
            <BackToTop />
        </>
    );
}
